export const GET_WORKSHOP_CONTACT = 'GET_WORKSHOP_CONTACT';
export const UPDATE_WORKSHOP_CONTACT = 'UPDATE_WORKSHOP_CONTACT';
